import React, { useState } from 'react'
import classnames from 'classnames'
import ExportModal from 'components/ExportModal'

import type { MarkupState } from 'EditorApp/types'

interface ExportLink {
  text: string
  icon: string
  href: string
}

interface Props {
  documentId: number
  isItem?: boolean
  printable?: boolean
  shareable?: boolean
  exportLinks: ExportLink[]
  markup: MarkupState
  fontFamily?: string
}

const ExportMenu = ({
  documentId,
  isItem,
  printable,
  shareable,
  exportLinks,
  markup,
  fontFamily,
}: Props) => {
  const [exportModalOpen, setExportModalOpen] = useState(false)

  if (exportLinks.length <= 0) {
    return null
  }

  const openExportModal = () => {
    setExportModalOpen(true)
  }

  return (
    <>
      <div
        className={classnames({
          ExportMenu: true,
          'button-item': isItem,
        })}
      >
        <button
          aria-label="export"
          className="randstad_button randstad_button--s"
          onClick={openExportModal}
        >
          export
        </button>
      </div>

      <ExportModal
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
        documentId={documentId}
        printable={printable}
        shareable={shareable}
        exportLinks={exportLinks}
        markup={markup}
        fontFamily={fontFamily}
      />
    </>
  )
}

export default ExportMenu
